import React from "react";
import {connect} from "react-redux";

import { history } from "state/history";

import { getSchoolIDList } from "state/teachers/selectors";

import EntitySelector from "components/EntitySelector";
import SchoolName from "components/teachers/SchoolName";

import "./SchoolSelector.css";

class SchoolSelector extends React.Component {
  
  changeSchool = schoolID => {
    history.push(this.props.generatePath(schoolID));
  }
  
  render() {
    const { schoolIDList, selectedSchoolID } = this.props;
    return (
      <EntitySelector
        cssBlockName="school-selector"
        entityIDList={schoolIDList}
        selectedEntityID={selectedSchoolID}
        loop={false}
        onSelectEntity={this.changeSchool}
      >
        { schoolID => <SchoolName schoolID={schoolID} /> }
      </EntitySelector>
    )
  }
  
}

export default connect(
  state => ({
    schoolIDList: getSchoolIDList(state)
  })
)(SchoolSelector);



// WEBPACK FOOTER //
// ./src/components/teachers/SchoolSelector.js